export function colorIsLight(color: string) {
    let r, g, b: number
    if (color.charAt(0) === '#') {
        const colorHex = +('0x' + color.slice(1))

        if (color.length < 5) {
            colorHex.toString().replace(/./g, '$&$&')
        }

        r = colorHex >> 16
        g = colorHex >> 8 & 255
        b = colorHex & 255
    } else {
        const splitColor = color.split(' ')
        r = Number(splitColor[0])
        g = Number(splitColor[1])
        b = Number(splitColor[2])
    }

    const hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b),
    )

    return (hsp > 127.5)
}

// Generated subset of css custom props
export const colors: string[] = (() => {
  const ret: string[] = []
    const colorList = ['yellow', 'orange', 'redpink', 'coral', 'violet', 'purple', 'blue', 'lightblue', 'seagreen', 'green']
    colorList.forEach((color) => {
    [10, 20].forEach((shade) => {
        ret.push(`--au-${color}-${shade}`)
    })
  })
  return ret
})()

// Returns a color from the given list, indexed by the given id property
export const getColorForId = (_id: string | number, colors: string[]) => {
  const id = String(_id)
  let hash = 0
  for (let i = 0; i < id.length; i++) {
    const char = id.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash |= 0 // Convert to 32bit integer
  }
  // Use the absolute value of the hash to ensure a positive index
  // Use modulo to loop back within the range of the color array length
  const index = Math.abs(hash) % colors.length
  return colors[index]
}
